<template>
  <v-toolbar
    :class="{ 'elevation-12': value, open: value }"
    class="nx-editor-toolbar"
    color="white"
    dense>

    <v-btn
      :class="{ 'accent--text': value }"
      class="ma-1 nx-editor-toolbar__add"
      @click="$emit('input', !value)"
      flat
      icon>
      <v-icon>add</v-icon>
    </v-btn>

    <div v-show="value">
      <v-btn
        @click="$emit('click', button.id, button)"
        :disabled="button.disabled"
        :key="button.id"
        :title="button.title"
        icon
        v-for="(button, index) in buttons"
        v-show="isButtonVisible(index)"
      >
        <v-icon v-html="button.icon"></v-icon>
      </v-btn>

      <v-btn
        @click.stop="showAllButtons = true"
        icon
        :title="$t('message.editor.button.showMore')"
        v-show="buttons.length > limit && !showAllButtons">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </div>

  </v-toolbar>
</template>

<script>
/**
 * EditorToolbar Component
 *
 *
 * @property {Boolean}  value      Controls the toolbar expanded state.
 * @property {[]}       [buttons]  Quill Blots object with configuration.
 * @property {Number}   [limit]    The maximun number of buttons displayed initially.
 */
export default {
  name: 'nx-editor-toolbar',
  props: {
    value: Boolean,
    buttons: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      active: false,
      showAllButtons: false,
    };
  },
  computed: {},
  watch: {
    value(value) {
      if (!value) {
        this.showAllButtons = false;
      }
    },
  },
  methods: {
    isButtonVisible(index) {
      return this.showAllButtons
        || index < (this.limit);
    },
  },
};
</script>

<style lang="stylus">
// base
$socialButton_dim = 24px;
$button_fgColor = #8C8C9C;
$button_fgColor_hover = #000;
$button_fgColor_active = #4ED19C;

.fa-tiktok {
  display: block;
  font-size: 24px !important;
  width: .85em;
  height: 1em;
  background: url('../../../assets/tiktok.svg');
  background-repeat: no-repeat;
}

// style
.nx-editor-toolbar.v-toolbar {
  border-radius: 2px;
  left: 2rem;

  &:not(.open) {
    border-radius: 50px;
  }

  .v-toolbar__content {
    height: auto !important;
    padding: 0;
  }

  .v-btn {
    color: $button_fgColor;

    &.v-btn--active {
      color: $button_fgColor_active;
    }

    .v-icon.fa:before {
      display: block;
      font-size: $socialButton_dim;
    }
  }

}

.module-editor-sidebar {
  .nx-editor-toolbar.v-toolbar {
    &:not(.open) {
      background-color: transparent !important;
    }
    &.open {
      .v-toolbar__content {
        height: 96px;
      }
    }
    .nx-editor-toolbar__add {
      align-self: baseline;
    }
  }
}

// Dialog button
.nx-block-headline {
  padding: 10px 0;
  color: #4E82D1;
  font-size: 20px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.19px;
}
</style>
